<template>
    <div class="nr">
        <div style="overflow:hidden;">
        <div  style="width:calc(100% - 750px);float: left;">
            <h2>{{ dwmc }}</h2>
            <p class="bz"><span>案由：</span><span>{{ anyou }}</span></p>
            <p class="bz"><span>处罚结果：</span><span style="line-height:24px;">{{ jieguo }}</span></p>
        </div>
        <div class="rt" style="width:750px;">
            <p>评查得分：<label><b>{{ result }}</b>&nbsp;分</label></p>
            <div class="btns">
                <el-button type="warning" plain icon="el-icon-upload2" size="small" @click="excelExporter()">评查结果导出</el-button>
                <el-button type="primary" plain icon="el-icon-view" size="small" @click="showFile()">查看案卷文档</el-button>
                <el-button type="primary" plain icon="el-icon-printer" size="small" v-show="row.daLsh" @click="getBg()">打印评查报告</el-button>
                <el-button type="primary" icon="el-icon-document" size="small" v-show="row.daLsh" @click="getBg()">预览评查报告</el-button>
                <el-button type="primary" size="small" @click="setBg()">生成评查报告</el-button>
                <el-button type="warning" size="small" @click="newPc()">重新评查</el-button>
            </div>
        </div>
        </div>
        <div class="shibieW">
            <div class="shibie left" >
                <div class="menus">
                    <el-scrollbar>
                        <h3 style="background:#eee;">&nbsp;已识别资料</h3>
                        <ul>
                            <li v-for="(item,index) in identifyList" :key="index" :class="isIndex == index?'active':''" @click="showWs(item,index,1)" >
                                <p><i class="el-icon-document"></i>&nbsp;{{ item.name }}</p>
                            </li>
                        </ul>
                        <h3 style="background:#eee;" v-if="identifyList2[0]">&nbsp;未识别资料</h3>
                        <ul>
                            <li v-for="(item,index) in identifyList2" :key="index" :class="isIndex2 == index?'active':''" @click="showWs(item,index,2)" >
                                <p><i class="el-icon-document"></i>&nbsp;{{ item.name ? item.name : '未识别资料'+item.pageid }}</p>
                            </li>
                        </ul>
                    </el-scrollbar>
                </div>
                <div class="imgW">
                    <el-scrollbar ref="myScrollbar2">
                        <p v-show="sbSrcs" v-for="(item,index) in sbSrcs" :key="index">
                            <img :src="item.fileUrl" @dblclick="showBig(item.fileUrl)" />
                        </p>
                        <p v-show="sbSrc"><img :src="sbSrc" @dblclick="showBig(sbSrc)" /></p>
                        <el-button type="success" size="small" v-show="identifyList[isIndex]" @click="showText(1)" style="position: absolute; bottom: 15px; left: 10px;box-shadow: 0px 0px 10px rgb(0 0 0 / 10%);">查看已识别内容</el-button>
                        <el-button type="success" size="small" v-show="identifyList2[isIndex2]" @click="showText(2)" style="position: absolute; bottom: 15px; left: 10px;box-shadow: 0px 0px 10px rgb(0 0 0 / 10%);">查看已识别内容</el-button>
                    </el-scrollbar>
                </div>
            </div>
            <div class="shibie right"  style="position: relative;">
                <el-tabs v-model="activeName" @tab-click="handleClick">
                    <!-- <el-tab-pane label=" 原始表单页 " name="first"></el-tab-pane> -->
                    <el-tab-pane label=" 问题项 " name="second" :disabled="numW==0?true:false">
                        <span slot="label">
                            <span class="span-box">
                                <span> 问题项</span>
                                <el-badge :value="numW" :type="numW > 0 ? 'danger':'info'"></el-badge>
                            </span>
                        </span>
                    </el-tab-pane>
                    <el-tab-pane label=" 合格项 " name="third" :disabled="numH==0?true:false">
                        <span slot="label">
                            <span class="span-box">
                                <span> 合格项</span>
                                <el-badge :value="numH" :type="numH > 0 ? 'success':'info'"></el-badge>
                            </span>
                        </span>
                    </el-tab-pane>
                    <!-- <el-tab-pane label=" 不予评查项 " name="fourth">
                        <span slot="label">
                            <span class="span-box">
                                <span> 不予评查项</span>
                                <el-badge :value="numB" type="info"></el-badge>
                            </span>
                        </span>
                    </el-tab-pane> -->
                    <el-tab-pane label=" 人工评查项 " name="fifth" :disabled="numR==0?true:false">
                        <span slot="label">
                            <span class="span-box">
                                <span> 人工评查项</span>
                                <el-badge :value="numR" :type="numR > 0 ? 'primary':'info'"></el-badge>
                            </span>
                        </span>
                    </el-tab-pane>
                </el-tabs>
                <div class="jgBox">
                    <div class="jgBtn">
                        <a :class="isbadge == '1' && num1 > 0?'active':(num1 == 0?'isBtn':'')" @click="pxShow('1')"><el-badge :value="num1" class="item" :type="isType"  :hidden="num1 > 0 ? false:true">主体</el-badge></a>
                        <a :class="isbadge == '2' && num2 > 0?'active':(num2 == 0?'isBtn':'')" @click="pxShow('2')"><el-badge :type="isType" :value="num2" class="item" :hidden="num2 > 0 ? false:true">事实</el-badge></a>
                        <a :class="isbadge == '3' && num3 > 0?'active':(num3 == 0?'isBtn':'')" @click="pxShow('3')"><el-badge :type="isType" :value="num3" class="item" :hidden="num3 > 0 ? false:true">证据</el-badge></a>
                        <a :class="isbadge == '4' && num4 > 0?'active':(num4 == 0?'isBtn':'')" @click="pxShow('4')"><el-badge :type="isType" :value="num4" class="item" :hidden="num4 > 0 ? false:true">程序</el-badge></a>
                        <a :class="isbadge == '5' && num5 > 0?'active':(num5 == 0?'isBtn':'')" @click="pxShow('5')"><el-badge :type="isType" :value="num5" class="item" :hidden="num5 > 0 ? false:true">法律适用</el-badge></a>
                        <a :class="isbadge == '6' && num6 > 0?'active':(num6 == 0?'isBtn':'')" @click="pxShow('6')"><el-badge :type="isType" :value="num6" class="item" :hidden="num6 > 0 ? false:true">案卷文书质量</el-badge></a>
                    </div>
                    <!-- <div class="jgmain"> -->
                    <div class="jgmain" v-loading="loading4"
    element-loading-text="数据处理中..."
    element-loading-background="rgba(0, 0, 0, 0.5)"> 
                        <el-alert v-show="isbadge == '1' && activeName == 'second' && num1 > 0" :title="'主体项最多20分，主体项实际扣分'+sjfz+'分，主体项最终得分'+zzfz+'分'"  type="error" :closable="false" style="margin-bottom: 10px;"> </el-alert>
                        <el-alert v-show="isbadge == '2' && activeName == 'second' && num2 > 0" :title="'事实项最多20分，事实项实际扣分'+sjfz+'分，事实项最终得分'+zzfz+'分'"  type="error" :closable="false" style="margin-bottom: 10px;"> </el-alert>
                        <el-alert v-show="isbadge == '3' && activeName == 'second' && num3 > 0" :title="'证据项最多10分，证据项实际扣分'+sjfz+'分，证据项最终得分'+zzfz+'分'"  type="error" :closable="false" style="margin-bottom: 10px;"> </el-alert>
                        <el-alert v-show="isbadge == '4' && activeName == 'second' && num4 > 0" :title="'程序项最多20分，程序项实际扣分'+sjfz+'分，程序项最终得分'+zzfz+'分'"  type="error" :closable="false" style="margin-bottom: 10px;"> </el-alert>
                        <el-alert v-show="isbadge == '5' && activeName == 'second' && num5 > 0" :title="'法律适用项最多20分，法律适用项实际扣分'+sjfz+'分，法律适用项最终得分'+zzfz+'分'"  type="error" :closable="false" style="margin-bottom: 10px;"> </el-alert>
                        <el-alert v-show="isbadge == '6' && activeName == 'second' && num6 > 0" :title="'文书质量项最多10分，文书质量项实际扣分'+sjfz+'分，文书质量项最终得分'+zzfz+'分'"  type="error" :closable="false" style="margin-bottom: 10px;"> </el-alert>
                        <el-scrollbar>
                            <div v-for="(item,index) in pcLists" :key="index" class="jgtext">
                                <p class="title">
                                    {{item.name2}} 
                                    <el-tag v-show="activeName == 'second'" type="danger" >扣{{item.sjfz}}分</el-tag>
                                    <el-button type="warning" size="small" @click="childnode(item,item.radio)" style="float:right;">子指标</el-button>
                                    <el-radio-group v-model="item.radio">
                                        <el-radio :label="1" @click.native.prevent="clickRadio1(item,index)">合格项</el-radio>
                                        <el-radio :label="2" @click.native.prevent="clickRadio2(item,index)">问题项</el-radio>
                                        <!-- <el-radio :label="3">不予评查项</el-radio> -->
                                    </el-radio-group>
                                </p>
                                <div class="ms" v-show="item.radio == 2">
                                    <b> 问题描述：</b>
                                    <span>
                                        <em>{{item.wenti}}</em>
                                        <i class="el-icon-edit" @click="editms(item,item.wenti,'问题描述',index)"></i>
                                    </span>
                                </div>
                                <div class="ms" v-show="item.radio == 1">
                                    <b> 合格描述：</b>
                                    <span style="background:#daedfe;border:solid 1px #1890ff">
                                        <em>{{item.wenti2}}</em>
                                        <i class="el-icon-edit" @click="editms(item,item.wenti2,'合格描述',index)"></i>
                                    </span>
                                </div>
                                <!-- <div style="text-align: right;margin-top:10px;">
                                    <el-button type="primary" size="small" @click="submit(item)">保存</el-button>
                                </div> -->
                            </div>
                        </el-scrollbar>
                        <div class="mark" v-if="markflag">
                            <div class="lineout">
                                <div class="tishi">{{ tishi }}</div>
                                <div class="line">
                                    <div class="linein" :style="{width: percent + '%'}"></div>
                                </div>
                                <div class="line-font">{{ percent }}%</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog title="案卷识别文书" :visible.sync="open2" top="20px" :width="isH?'700px':'1200px'" append-to-body :close-on-click-modal="false" ref="rotate">
            <div style="text-align:center;"><el-button type="warning" size="small" @click="rotate">旋转</el-button></div>
            <p v-show="bigSrcs" v-for="(item,index) in bigSrcs" :key="index" :style="{'width':isH?'100%':'70%'}" style="margin: 0px auto;">
                <img :src="item" style="width: 100%;" />
            </p>
            <p v-show="bigSrc" ref="rotate" :style="{'width':isH?'100%':'70%'}" style="margin: 0px auto;"><img :src="bigSrc"  style="width: 100%;" /></p>
        </el-dialog>
        <el-dialog :title="title" :visible.sync="open3" top="15vh" width="700px" append-to-body  :close-on-click-modal="false">
            <el-form ref="form" :model="form" :rules="rules" label-width="100px">
                <el-form-item :label="title+':'" prop="text">
                    <el-input type="textarea" :rows="10" v-model="form.text"></el-input>
                </el-form-item>
                <el-form-item label="扣分值:" prop="sjfz" v-if="title == '问题描述'">
                    <el-input type="number" oninput="value=value.replace(/\D|^0/g,'')" v-model="form.sjfz" style="width:120px;"></el-input>
                    <span style="color: #ff0000;">&nbsp;最高扣分值：<b>{{ form.fz }}</b>。注：扣分值必须{{ form.fz_min==0?'>':'≥' }}{{form.fz_min}}且≤{{ form.fz }}。</span>
                </el-form-item>
                <el-form-item style="text-align:right;">
                    <el-button size="small" type="primary" @click="queding('form')">确定</el-button>
                    <el-button size="small" @click="cancle">取消</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        <div v-show="open4" class="tzbox" style="z-index: 9000; position: fixed;background: rgba(0,0,0,0.5); top: 0; right: 0; bottom: 0; left: 0; overflow: auto;  margin: 0;">
            <div style="width:800px; position: relative; z-index: 9999;top: 10vh; left: 50%; margin-left: -300px;height: auto;box-shadow: 0 1px 3px rgb(0 0 0 / 30%);">
                <vue-drag-resize :isActive="isActive" :isResizable="false" :preventActiveBehavior="true">
                    <h3 style="background: #e6e6e6;font-weight: normal; padding: 0px 20px 0px; line-height: 48px; border-radius: 4px 4px 0 0;">已识别内容
                    <i class="el-icon el-icon-close" @click="open4 = false" style="color: #909399;float:right;font-size:16px;margin-top: 18px;cursor: pointer;"></i></h3>
                    <div style="width:100%; background:#fff;padding:20px 0px 0; overflow: hidden;">
                        <label style="color:#ff0000; float:left; margin:0 10px 0 45px; font-weight: bold;">* 双击已识别文字{{isActive?'关闭':'开启'}}拖拽</label>
                        <el-switch v-model="isActive" active-text=""></el-switch></div>
                    <p  @dblclick="beginTz()" style="padding:15px 45px 40px;line-height:30px;font-size:15px;text-indent: 2rem;font-weight: bold; background: #fff; border-radius: 0 0 4px 4px;">{{ contentL }}</p>
                </vue-drag-resize>
            </div>
        </div>
        <el-dialog title="子指标详情" :visible.sync="open5" top="8vh" width="1000px" append-to-body  :close-on-click-modal="false">
            <div v-for="(item,index) in pcListSon" :key="index" class="jgtext">
                <p class="title">
                    {{index+1}}、{{item.name2}} 
                    <!-- <el-tag v-show="activeName == 'second'" type="danger" >扣{{item.sjfz}}分</el-tag>
                    <el-radio-group v-model="item.radio" style="width:99%;">
                        <el-radio :label="1" @click.native.prevent="clickRadio1(item,index)">合格项</el-radio>
                        <el-radio :label="2" @click.native.prevent="clickRadio2(item,index)">问题项</el-radio>
                    </el-radio-group> -->
                </p>
                <div class="ms" v-if="item.wenti">
                    <b> 问题描述：</b>
                    <span>
                        <em style="white-space: normal;">{{item.wenti}}</em>
                        <!-- <i class="el-icon-edit" @click="editms(item,item.wenti,'问题描述',index)"></i> -->
                    </span>
                </div>
                <div class="ms" v-else>
                    <b> 合格描述：</b>
                    <span style="background:#daedfe;border:solid 1px #1890ff">
                        <em style="white-space: normal;">{{item.wenti2}}</em>
                        <!-- <i class="el-icon-edit" @click="editms(item,item.wenti2,'合格描述',index)"></i> -->
                    </span>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import VueDragResize from 'vue-drag-resize';
import axios from 'axios'
import qs from 'qs'
export default {
    name: "Layout",
    props:['pcId','row','ispc'],
    watch:{
        pcId(val,val2){
            if(val != val2){
                this.activeName = 'second'
                this.isbadge = 1
                this.isType = 'danger'
                this.getListF()
                this.getList()
            }
        },
    },
    data() {
        return {
            tishi: "案卷正在评测请耐心等待!",
            dwmc:'',
            anyou:'',
            jieguo:'',
            sbSrc:'',
            sbSrcs:[],
            identifyList:[],
            isIndex:0,
            identifyList2:[],
            isIndex2:-1,
            bigSrc:'',
            bigSrcs:[],
            activeName:'second',
            AllList:[],
            pcList:[],
            pcLists:[],
            clickIndex:0,
            isbadge:'1',
            num:0,
            num1:0,
            num2:0,
            num3:0,
            num4:0,
            num5:0,
            num6:0,
            arr1:[],
            arr2:[],
            arr3:[],
            arr4:[],
            arr5:[],
            arr6:[],
            numW:0,
            numH:0,
            numB:0,
            numR:0,
            sjfz:0,
            zzfz:0,
            result:0,
            loading:false,
            open2:false,
            markflag:false,
            form:{
                text:'',
                sjfz:0,
                fz:0,
                fz_min:0
            },
            rules:{
                text:[{ required: true, message: "错误描述不能为空", trigger: "blur" }],
                sjfz:[{ required: true, message: "扣分值不能为空", trigger: "blur" }]
            },
            title:'',
            isIndex:'',
            isIndex2:'',
            isType:'danger',
            editArr:[],
            open3:false,
            open4:false,
            contentL:'',
            deg:0,
            isH:true,
            isActive:true,
            open5:false,
            pcListSon:[],
            radio:null,
            percent: 0,
            customColor: '#409eff',
            loading4:false,
            baseUrl:'',
            progressTimer: null // 添加进度条定时器引用
        }
    },
    components: {
        VueDragResize
    },
    computed: {
    },
    created() {
        console.log(this.row)
    },
    mounted() {
        let user = JSON.parse(sessionStorage.getItem("userdata"));
        this.baseUrl = user.baseUrl
        this.getListF()
        this.getList()
    },
    methods: {
        async childnode(item,radio){
            
            this.radio = item.radio || radio
            this.pcListSon = []
            let flag = (this.radio == 1 ? 0 : -1)
            axios({
                method: 'get',
                url: `${this.Global._baseUrl}`,
                params: {
                    act: "getZncpSub",
                    pcId: `${escape(this.pcId)}`,
                    zbm:item.zbm,
                    flag:flag
                },
                headers: { 'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'}
            }).then(res => {
                if(res.data){
                    this.open5 = true
                    this.pcListSon = res.data
                }else{
                    this.$message({
                        message: '该项暂无子节点',
                        type: 'error'
                    });
                }
                
            })
        },
        beginTz(){
            this.isActive = !this.isActive
        },
        async getListF(){
            this.sbSrc = ''
            this.sbSrcs = []
            this.identifyList = []
            this.isIndex = 0
            this.identifyList2 = []
            this.isIndex2 = -1
            this.bigSrc = ''
            this.bigSrcs = []
            this.dwmc = ''
            this.anyou = ''
            this.jieguo = ''
            if(this.row){
                this.dwmc = this.row.dwmc
                this.anyou = this.row.anyou
                this.jieguo = this.row.penalize
            }
            this.loading = true
            
            axios({
                timeout: 3600000, // 单位：毫秒（6 分钟）
                method: 'post',
                url: this.baseUrl+`/yz/getDanganList`,
                headers: { // 添加请求头
                    "Content-Type": "application/json" // 明确声明为 JSON 格式
                },
                data: {
                    pcId:this.pcId
                }
            })
            .then(res => {
                this.loading = false
                console.log(res,1496)
                this.openYz = true
                this.isIndex = 0
                this.isIndex2 = 0
                console.log(res.data,15000)
                if(res.data && res.data.data){
                    let data = res.data.data
                    this.identifyList = data.danganList
                    console.log(this.identifyList,1500)
                    console.log(this.identifyList.length)
                    if(this.identifyList && this.identifyList.length > 0){
                        console.log(this.identifyList[0],1502)
                        if(this.identifyList[0].pageCount == 1){
                            console.log(this.identifyList[0].fileUrlsList)
                            this.sbSrc = this.identifyList[0].fileUrlsList[0].fileUrl
                        }else{
                            this.sbSrcs = this.identifyList[0].fileUrlsList
                        }
                    }
                    this.identifyList2 = data.weidanganList
                    console.log(this.identifyList2,1347)
                    console.log(this.identifyList2.length)
                    if(this.identifyList2 && this.identifyList2.length > 0){
                        console.log(123)
                        let form = this.identifyList2[0]

                        form.pageCount = form.pageCount ? form.pageCount : 1
                        form.errlog = form.errlog ? form.errlog : '无法识别文件名称'  
                        this.form = form
                        this.content = ''
                        this.showTextYz(2)
                    }
                    
                    
                }
                
            })
            .catch(error => {
                this.loading = false
                this.loadingMl = false
                this.$message({
                    message: '解析失败，请重试！',
                    duration: 5000,
                    type: 'error'
                });
            });
        },
        getList(){
            if(this.ispc == 0){
                this.getList2()
            }else{
                this.getList3()
            }
        },
        qingchu(){
            this.pcLists = []
            this.result = 0
            this.AllList = []
            this.pcList = []
            this.numR = 0
            this.numW = 0
            this.numH = 0
            this.numB = 0
            this.num = 0
            this.num1 = 0
            this.num2 = 0
            this.num3 = 0
            this.num4 = 0
            this.num5 = 0
            this.num6 = 0
            this.arr1 = []
            this.arr2 = []
            this.arr3 = []
            this.arr4 = []
            this.arr5 = []
            this.arr6 = []
            this.sjfz = 0
            this.zzfz = 0
        },
        async getList3(){
            this.qingchu()
            this.loading4 = true
            this.isbadge = 1
            this.isType = 'danger'
            this.activeName = 'second'
            let user = JSON.parse(sessionStorage.getItem("userdata"));
            let dm = user.dm
            axios({
                timeout: 3600000, // 单位：毫秒（6 分钟）
                method: 'post',
                url: this.baseUrl+`/guizeApi/GetZncp2Info`,
                headers: { // 添加请求头
                    "Content-Type": "application/json" // 明确声明为 JSON 格式
                },
                data: {
                    pcId:`${escape(this.pcId)}`,
                }
            }).then(res => {
                this.loading4 = false
                console.log(res,443)
                if(res.data.code == 500){
                    this.$message({
                        message: res.data.msg,
                        type: 'error'
                    });
                }else{
                    if(res.data.data){
                        let data = res.data.data
                        console.log(data,446)
                        this.result = data.hejiFenshu
                        this.AllList = data
                        this.pcList = data.error
                        this.numR = data.shou ? data.shou.length : 0
                        this.numW = data.error ? data.error.length : 0
                        this.numH = data.ok ? data.ok.length : 0
                        // this.numB = data.No.length
                        
                        this.getArr(this.pcList)
                        this.pcList.forEach(item => {
                            item.radio = 2
                        })
                    }
                }
            }).catch(error => {
                console.error( error);
                this.loading4 = false
            });
        },
        async getList2(){
            this.qingchu()
            this.isbadge = 1
            this.isType = 'danger'
            this.activeName = 'second'
            this.percent = 0
            this.loading4 = true
            axios({
                method: 'post',
                url: this.baseUrl+`/yz/imageToAliYz`,
                headers: { // 添加请求头
                    "Content-Type": "application/json" // 明确声明为 JSON 格式
                },
                data: {
                    pcId:`${escape(this.pcId)}`,
                }
            })
            .then(response => {
                console.log(response.data,511);
                if(response.data.msg){
                    this.zhinengpingcha(response.data.msg)
                }
            })
            .catch(error => {
                this.loading4 = false
                this.$message.error('评测失败，请重新评查!')
            });
        },
        zhinengpingcha(sessionId){
            let user = JSON.parse(sessionStorage.getItem("userdata"));
            let dm = user.dm;
            let cmid = user.c_mid;
            console.log(cmid);
            
            // 一旦开始执行请求就启动进度条
            this.getJindutiao();
            
            axios({
                timeout: 3600000, // 单位：毫秒（6 分钟）
                method: 'post',
                url: this.baseUrl+`/guizeApi/GetZncp`,
                headers: { // 添加请求头
                    "Content-Type": "application/json" // 明确声明为 JSON 格式
                },
                data: {
                    dm:dm,
                    cmid:cmid,
                    pcId:`${escape(this.pcId)}`,//'202300333',
                    type:`${escape('档案评测')}`,
                    sessionId:sessionId
                }
            }).then(res => {
                if(res.data.data){
                    this.getList3();
                    //let data = res.data.data
                    //this.result = data.hejiFenshu
                    //this.AllList = data
                    //this.pcList = data.error
                    //this.numR = data.shou ? data.shou.length : 0
                    //console.log(data.shou)
                    //this.numW = data.error ? data.error.length : 0
                    //this.numH = data.ok ? data.ok.length : 0
                    //this.isbadge = 1
                    //this.isType = 'danger'
                    //this.activeName = 'second'
                    //this.getArr(this.pcList)
                    //this.pcList.forEach(item => {
                    //    item.radio = 2
                    //})
                    this.loading = false;
                    this.$emit('handleCall',1);
                }
            }).catch(error => {
                this.loading4 = false;
                this.$message.error('评测失败，请重新评查!');
                // 请求失败时停止进度条
                this.stopJindutiao();
            });
        },

        getJindutiao() {
            // 清除可能存在的旧定时器
            if (this.progressTimer) {
                clearInterval(this.progressTimer);
            }
            
            setTimeout(() => {
                this.progressTimer = setInterval(() => {
                    axios({
                        method: 'post',
                        url: this.baseUrl+`/xx/getZncpTime`,
                        headers: { // 添加请求头
                            "Content-Type": "application/json" // 明确声明为 JSON 格式
                        },
                        data: {
                            pcId:this.pcId,
                        }
                    }).then(res => {
                        let data = res.data.msg;
                        if(data != 100){
                            if(data > 0){
                                this.loading4 = false;
                                this.markflag = true
                                this.percent = data;
                            }
                        }else if(data == 100){
                            this.tishi = "评测完成!";
                            setTimeout(() => {
                                this.markflag = false;
                                clearInterval(this.progressTimer);
                            },1000);
                        }
                    }).catch(error => {
                        this.loading4 = false;
                        this.$message.error('评测失败，请重新评查!');
                        // 如果获取进度失败，也停止进度条
                        this.stopJindutiao();
                    });
                },1000);
            },1000);
        },

        stopJindutiao() {
            // 停止进度条
            if (this.progressTimer) {
                clearInterval(this.progressTimer);
                this.progressTimer = null;
            }
            this.tishi = "评测失败!";
        },
        excelExporter(){
            axios({
                method: 'post',
                url: this.baseUrl+`/guizeApi/excelExporter`,
                headers: { // 添加请求头
                    "Content-Type": "application/json" // 明确声明为 JSON 格式
                },
                data: {
                    pcId:`${escape(this.pcId)}`,//'202300333',
                }
            }).then(res => {
                console.log(res.data)
                let url = res.data.msg.replace(/\\/g,"/")
                console.log(url)
                window.open(url,'_blank')
            })
        },
        newPc(){
            this.getList2()
        },
        checkSameData(data){
            let obj = {}
            data.forEach((item,index) => {
                const {wenti,wenti2,name2Sub,name2} = item
                if(obj[name2]){
                    obj[name2]["wenti"] += `${wenti}`
                    obj[name2]["wenti2"] += `${wenti2}`
                    obj[name2]["name2Sub"] += `${name2Sub}`
                }else{
                    obj[name2] = item
                }
            })
            let result = Object.values(obj);
            return result
        },
        showFile(){
            if(this.row){
                if(this.row.fileUrl){
                    window.open(this.row.fileUrl,'_blank')
                }else{
                    this.$message({
                        message: '该案卷文档不存在！',
                        type: 'error'
                    });
                }
            }
        },
        newUpdate(){
            this.$forceUpdate();
        },
        showWs(val,index,num){
            // 回到顶部
            this.$refs.myScrollbar2.wrap.scrollTop= 0;
            this.sbSrc = ''
            this.sbSrcs = []
            this.isIndex = index
            if(val.pageCount == 1){
                this.sbSrc = val.fileUrlsList[0].fileUrl
                console.log(this.sbSrc,1520)
            }else{
                this.sbSrcs = val.fileUrlsList

            }
        },
        showBig(src){
            this.bigSrc = src
            this.open2 = true
            this.isH = true
            this.$refs.rotate.style.transform = `rotate(0deg)`
        },
        // 旋转图片
        rotate () {
            this.isH = false
            this.deg += 90
            if (this.deg >= 360) {
                this.deg = 0
            }
            this.$refs.rotate.style.transform = `rotate(${this.deg}deg)`
        },
        getzt(item,index){
            item.iszhankai = !item.iszhankai
            this.$forceUpdate()
        },
        handleClick(tab, event) {
            this.pcList = []
            this.pcLists = []
            // if(tab.name == 'first'){
            //     this.pcList = this.AllList.ALL 
            //     this.getArr(this.AllList.ALL)
            // }else 
            if(tab.name == 'second'){
                this.isType = 'danger'
                this.AllList.error.forEach(item => {
                    item.radio = 2
                    this.pcList.push(item) 
                })
                this.getArr(this.pcList)
            }else if(tab.name == 'third'){
                this.isType = 'success'
                this.AllList.ok.forEach(item => {
                    item.radio = 1
                    this.pcList.push(item) 
                })
                this.getArr(this.pcList)
            }else if(tab.name == 'fourth'){
                this.isType = 'info'
                this.AllList.No.forEach(item => {
                    item.radio = 3
                    this.pcList.push(item) 
                })
                this.getArr(this.pcList)
            }else if(tab.name == 'fifth'){
                this.isType = 'primary'
                this.AllList.shou.forEach(item => {
                    item.radio = 1
                    this.pcList.push(item) 
                })
                this.getArr(this.pcList)
            }
        },
        pxShow(val){
            this.isbadge = val
            this.pcLists = []
            if(val == '1'){
                this.pcLists = this.arr1
                if(this.activeName == 'second'){
                    this.getFz(this.arr1,20)
                }
            }else if(val == '2'){
                this.pcLists = this.arr2
                if(this.activeName == 'second'){
                    this.getFz(this.arr2,20)
                }
            }else if(val == '3'){
                this.pcLists = this.arr3
                if(this.activeName == 'second'){
                    this.getFz(this.arr3,10)
                }
            }else if(val == '4'){
                this.pcLists = this.arr4
                if(this.activeName == 'second'){
                    this.getFz(this.arr4,20)
                }
            }else if(val == '5'){
                this.pcLists = this.arr5
                if(this.activeName == 'second'){
                    this.getFz(this.arr5,20)
                }
            }else if(val == '6'){
                this.pcLists = this.arr6
                if(this.activeName == 'second'){
                    this.getFz(this.arr6,10)
                }
            }
        },
        getArr(data){
            console.log(data,701)
            this.num1 = 0
            this.num2 = 0
            this.num3 = 0
            this.num4 = 0
            this.num5 = 0
            this.num6 = 0
            this.arr1 = []
            this.arr2 = []
            this.arr3 = []
            this.arr4 = []
            this.arr5 = []
            this.arr6 = []
            data.forEach((item,index) => {
                if(item.name1 == '主体'){
                    this.num1 ++;
                    this.arr1.push(item)
                }else if(item.name1 == '事实'){
                    this.num2 ++;
                    this.arr2.push(item)
                }else if(item.name1 == '证据'){
                    this.num3 ++;
                    this.arr3.push(item)
                }else if(item.name1 == '程序'){
                    this.num4 ++;
                    this.arr4.push(item)
                }else if(item.name1 == '法律适用'){
                    this.num5 ++;
                    this.arr5.push(item)
                }else if(item.name1 == '文书质量'){
                    this.num6 ++;
                    this.arr6.push(item)
                }
            })
            
            switch(true){
                case (this.num1>0):
                    this.isbadge = 1;
                    break;
                case (this.num2>0):
                    this.isbadge = 2;
                    break;
                case (this.num3>0):
                    this.isbadge = 3;
                    break;
                case (this.num4>0):
                    this.isbadge = 4;
                    break;
                case (this.num5>0):
                    this.isbadge = 5;
                    break;
                case (this.num6>0):
                    this.isbadge = 6;
                    break;
                default:
                    return this.isbadge = 1;
            }
            this.pxShow(this.isbadge)
            this.$forceUpdate();

            
            // if(this.num1 == 0){
            //     if(this.num2 == 0){
            //         if(this.num3 == 0){
            //             if(this.num4 == 0){
            //                 if(this.num5 == 0){
            //                     if(this.num6 == 0){
            //                         this.isbadge = 1
            //                     }else{
            //                         this.isbadge = 6
            //                     }
            //                 }else{
            //                     this.isbadge = 5
            //                 }
            //             }else{
            //                 this.isbadge = 4
            //             }
            //         }else{
            //             this.isbadge = 3
            //         }
            //     }else{
            //         this.isbadge = 2
            //     }
            // }else{
            //     this.isbadge = 1
            // } 
        },
        getFz(arr,num){
            let nn = 0
            arr.forEach(item => {
                if(Number(item.sjfz) > 0){
                    nn += Number(item.sjfz)
                }
            })
            this.sjfz = nn
            if(nn <= num){
                this.zzfz = num - nn
            }else{
                this.zzfz = 0
            }
        },
        async showText(val){
            this.contentL = ''
            let arr = []

            if(val == 1 && this.identifyList[this.isIndex]){
                arr = this.identifyList[this.isIndex].fileUrlsList
            }else if(val == 2 && this.identifyList2[this.isIndex2]){
                arr = this.identifyList2[this.isIndex2].fileUrlsList
            }
            if(val == 1){
                this.contentL = ''
                arr.forEach(item => {
                    this.contentL += item.nr2 
                })
                this.open4 = true
            }else if(val == 2){
                this.content = ''
                arr.forEach(item => {
                    this.content += item.nr2
                })
                this.$forceUpdate()
            }
        },
        clickRadio1(item,index){
            this.$confirm("是否确定该项为合格项?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                item.radio = 1
                this.submit(item)
            }).catch(() => {
                return false
            })
        },
        clickRadio2(item,index){
            console.log(item)
            this.title = '问题描述'
            this.isIndex = index
            this.form.radio = 2
            this.form.text = item.wenti
            this.form.sjfz = 0
            this.form.fz = Number(item.fz)
            this.form.fz_min = Number(item.fz_min) > 0 ? Number(item.fz_min) : 0
            this.open3 = true
        },
        getNewRadio(item,index){
            // if(item.radio == 1){
            //     item.wenti2 = item.wenti2 ? item.wenti2 : ''
            //     item.wenti = ''
            //     this.$confirm("是否确定该项为合格项?", "提示", {
            //         confirmButtonText: "确定",
            //         cancelButtonText: "取消",
            //         type: "warning"
            //     }).then(async () => {
            //         this.submit(item)
            //     }).catch(async () => {
            //         item.radio == 2
            //     })
            // }else if(item.radio == 2){
            //     item.wenti = item.wenti ? item.wenti : ''
            //     item.wenti2 = ''
            //     this.title = '问题描述'
            //     this.form.text = item.wenti
            //     this.form.sjfz = item.sjfz
            //     this.open3 = true
            // }
            // this.$forceUpdate()
        },
        editms(item,val,text,num1){
            this.isIndex = num1
            this.title = text
            this.form.radio = item.radio
            this.form.text = val
            this.form.sjfz = item.sjfz || 0
            this.form.fz = Number(item.fz)
            this.form.fz_min = Number(item.fz_min) > 0 ? Number(item.fz_min) : 0
            this.open3 = true
        },
        queding(form){
            if(this.form.radio == 1){
                let that = this
                let obj = that.pcLists[that.isIndex]
                let item = {id:obj.id,radio:1,wenti2:that.form.text,zbm:obj.zbm,sjfz:0}
                that.submit(item)
                that.open3 = false
            }else{
                this.$refs[form].validate(async valid => {
                    if (valid) {
                        let that = this
                        let obj = that.pcLists[that.isIndex]

                        if(Number(that.form.sjfz) > 0){
                            if(Number(that.form.sjfz) > Number(that.form.fz)){
                                this.$message({
                                    message: '扣分分值不得大于最大值！！！',
                                    type: 'error'
                                });
                                return false
                            }else if(Number(that.form.sjfz) < Number(that.form.fz_min)){
                                this.$message({
                                    message: '扣分分值不得小于最小值！！！',
                                    type: 'error'
                                });
                                return false
                            }else{
                                let item = {id:obj.id,radio:2,wenti:that.form.text,zbm:obj.zbm,sjfz:Number(that.form.sjfz)}
                                that.submit(item)
                                that.open3 = false
                            }
                        }else{
                            console.log(that.form.sjfz)
                            this.$message({
                                message: '请填写该问题项扣分分值！！！',
                                type: 'error'
                            });
                            return false
                        }
                    }
                })
            }
        },
        cancle(){
            this.open3 = false
        },
        setBg(){
            axios({
                method: 'post',
                url: this.baseUrl+`/login/setPcbg`,
                headers: { // 添加请求头
                    "Content-Type": "application/json" // 明确声明为 JSON 格式
                },
                data: {
                    pcId:this.pcId,
                }
            })
            .then(response => {
                console.log(response.data,1194)
                if (response.data.code == 0) {
                    const user = JSON.parse(sessionStorage.getItem("userdata") || "{}");
                   const baseUrl = "https://xxswj.hzxhykj.com/pingcha1/";
                    const url = baseUrl + response.data.msg;
                    window.open(url,'_blank')
                    this.row.daLsh = true
                }
            })
            .catch(error => {
                this.$message.error('获取数据失败！');
                console.error('There was an error!', error);
            });
        },
        getBg(){
            axios({
                method: 'post',
                url: this.baseUrl+`/login/getPcbg`,
                headers: { // 添加请求头
                    "Content-Type": "application/json" // 明确声明为 JSON 格式
                },
                data: {
                    pcId:this.pcId,
                }
            })
            .then(response => {
                console.log(response.data,1194)
                if (response.data.code == 0) {
                   const user = JSON.parse(sessionStorage.getItem("userdata") || "{}");
                   const baseUrl = "https://xxswj.hzxhykj.com/pingcha1/";
                    const url = baseUrl + response.data.msg;
                    window.open(url,'_blank')
                }
            })
            .catch(error => {
                this.$message.error('获取数据失败！');
                console.error('There was an error!', error);
            });
        },
        submit(item){
            console.log(item,987)
            let obj = {}
            var neirong = ''
            if(item.radio == 1){
                neirong = item.wenti2
                item.sjfz = 0
            }else if(item.radio == 2){
                neirong = item.wenti
                item.sjfz = item.sjfz
            }else{
                neirong = ''
                item.sjfz = 0
            }
            obj={id:item.id,neirong:neirong,zbm:item.zbm,fz:item.sjfz}
            console.log(obj,item.radio)
            axios({
                method: 'post',
                url: this.baseUrl+`/pdfApi/setZncpTiaomu`,
                headers: { // 添加请求头
                    "Content-Type": "application/json" // 明确声明为 JSON 格式
                },
                data: {
                    id:item.id,
                    neirong:neirong,
                    zbm:item.zbm,
                    fz:item.sjfz,
                    questionType:item.radio
                }
            })
            .then(res => {
                this.$message({
                    message: '保存成功,请点击生成评查报告，生成新的评查报告！！！',
                    type: 'success'
                });
                this.getList3()
            }).catch(res => {
                this.$message({
                    message: '保存失败，请重新填写',
                    type: 'error'
                });
            })
        }
    }
}
</script>


<style scoped>
.nr h2{color:#000;margin-bottom: 5px;}
.bz span{line-height: 28px;}
.bz span:first-child{width: 76px; float: left; text-align: right;}
.bz span:last-child{color:#000;font-weight: bold;}
.rt{float: right; text-align: right; margin-top:10px;}
.rt p{text-align: right; margin-bottom: 15px;}
.rt p label{color:#1890ff; font-family: 'shuzi';}
.rt p label b{ font-size: 20px;}
.shibieW{width: 100%; overflow: hidden;}
.shibie{float: left; width: calc((100% - 30px) / 2 ); height: 68vh;}
.left{margin-top: 10px;}
.menus{ width: 200px;  height: calc(100% - 2px); float: left;    border: solid 1px #ddd;}
.shibie >>> .el-scrollbar { width: 100%; height: 100%;}
.shibie >>> .el-scrollbar__bar.is-horizontal{opacity: 0;}
.shibie >>> .el-scrollbar__wrap { overflow-y: auto !important; overflow-x: hidden;}
.shibie >>> .el-scrollbar__view{min-height: 100%;}
.right .imgW >>> .el-scrollbar__view{ background: #eef3f9;}
.right >>> .el-tabs__header{margin:0;}
.shibieW .right{float: right;}
.shibie h3{background: #fff; width:100%; color:#000; border-bottom: solid 1px #ddd; line-height: 36px; margin-bottom: 8px;}
.menus ul{width: 185px;margin-right: 10px; padding-left: 10px;}
.menus ul li{line-height: 36px; width: 100%; overflow: hidden; white-space: normal; text-overflow: ellipsis; cursor: pointer;}
.menus ul li.active{color:#1890ff;}
.imgW{width: calc(100% - 214px);  height: calc(100% - 2px);float: right;    border: solid 1px #ddd;}
.imgW img{ width: 100%;}
.imgW h3{border-bottom: none; padding:10px 0;}
.imgW h3 span{ border-left: solid 4px #1890ff; line-height: 1; padding-left: 6px;display: block;}
.imgW >>> .el-form{ padding: 10px 0 10px 10px; width: calc(100% - 45px);}
.bigimg{width: 100%;}

.jgBox{ width: 100%; height:calc(100% - 54px); overflow: hidden;padding-top:15px;}
.jgBtn{width:130px;height:100%;float: left;}
.jgBtn a{ display: block; width: 110px;height:50px; line-height: 50px;border: solid 2px #ccc; border-radius: 4px; text-align: center; margin-bottom: 15px; cursor: pointer; color:#000; font-weight: bold;}
.jgBtn a.active{ color:#1890ff; border: solid 2px #1890ff;}
.jgBtn a.isBtn{color: #ccc;cursor: not-allowed;  border-color: #eee;}
.jgBtn a .item{ width: 110px;}

li{ list-style: none;}
.info{ width: calc(100% - 5rem); padding: 0 2.5rem;height: calc(100% - 3rem);max-height: 85vh;}
.info h3{ text-align: center;padding: 1.3rem 0 1rem;margin:0; font-size: 1.2rem; letter-spacing: 1px; color:#fff;}
.jgmain{ float: right; width: calc(100% - 130px); height:100%;position: relative;}
.jgmain >>> .el-scrollbar{width: 100%;height:calc(100% - 40px);}
.jgmain >>> .el-scrollbar__wrap {
     width: calc(100% + 25px); /*将垂直滚动条挤到可视区域之外*/
     height: 100%; /*将水平滚动条挤到可视区域之外*/
     overflow-x: hidden;
 }
 .jgmain >>> .el-scrollbar__view{width: calc(100% - 0.4rem);}
 .jgmain >>> .el-scrollbar__bar.is-vertical { width: 0.2rem; right: 0; background-color: rgba(144,147,153,.3);}
 .jgmain >>> .el-scrollbar__thumb { width: 0.2rem; height: 42.5%; background-color: rgba(50, 137, 255, 0.3);}

.jgtext{ border: 1px solid #ddd; margin-bottom: 20px; border-radius: 4px; position: relative; width: calc(100% - 42px);padding: 10px;}
.jgtext .title{line-height: 30px; text-align: left; font-weight: 600; font-size: 15px;  color: #000;}
.jgtext ul{width: calc(100% - 20px); height:100%; padding:0 a0px; color:#000;}
.jgtext li{line-height: 32px;  border-bottom: 1px dashed #dfdfdf;font-size: 14px; padding-bottom:10px;}
.jgtext li:last-child{border-bottom: none; padding-bottom:0;}
.jgtext .ms{overflow: hidden;}
.jgtext .ms b{width:80px;float: left; text-align: right; font-weight: normal;line-height: 38px;}
.jgtext .ms span{background:#ffdedd;border:solid 1px #fd4948;float: left; width: calc(100% - 83px); line-height: 36px; min-height: 36px;}
.jgtext .ms span em{ float: left;width: calc(100% - 40px);padding:0 5px; font-style: normal;overflow: hidden; white-space: nowrap; text-overflow: ellipsis;}
.jgtext .ms span i{float:right; width:24px;height:24px;line-height:24px;margin:6px 5px 0 0;background: #fff;border-radius: 2px; text-align:center;color: #1890ff; cursor: pointer;}
.jgtext .title b{ float: left; font-style: normal; font-size: 0.8rem; width: 0.75rem;height:0.75rem; margin:0.6rem 0.5rem 0 0; cursor: pointer;}

.imgW >>> .el-textarea.is-disabled .el-textarea__inner { color: #606266;}
.jgmain >>> .el-radio-group{ width: calc(100% - 20px); margin-left: 20px;}
.jgmain >>> .el-tag{ margin-top:0.3rem; padding:0 0.5rem; border-radius: 12px;height:24px; line-height: 24px;}
.jgmain >>> .el-tag.el-tag--info { background: none !important; border-color: #999999; color: #000000;}
.jgmain >>> .el-tag.el-tag--danger { border-color:none !important ; color: #fe4949;}
.jgmain >>> .el-tag.el-tag--success { background: none !important; border-color: #098f09; color: #098f09;}

.tzbox >>> .content-container{min-width: 800px !important;height:auto !important;}
.tzbox >>> .vdr.active::before{ display: none;}
.mark{
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.3);
    top: 0px;
    left: 0px;
    z-index: 9999;
    display: flex;
    justify-content: center;
    align-items: center;
}
.lineout{
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}
.line{
    width: 50%;
    background: #fff;
    height: 10px;
    border-radius: 300px;
    box-sizing: border-box;
    margin-bottom: 20px;
}
.line-font{
    color: #fff;
    font-size: 18px;
}
.linein{
    height: 100%;
    background: #1890ff;
    border-radius: 300px;
}
.tishi{
    font-size: 16px;
    color: #fff;
    margin-bottom: 10px;
}

.jgBox >>> .el-loading-spinner{top:20vh}
.jgBox >>> .el-loading-spinner .el-loading-text{color:rgba(255,255,255,0.7);    font-size: 16px;}
.jgBox >>> .el-loading-spinner .path{stroke: rgba(255,255,255,0.7);}
.jgBox >>> .el-loading-spinner .circular {
    height: 62px;
    width: 62px;}
</style>